import Vue from 'vue';
import { gsap } from 'gsap';

Vue.component('projects-filter-component', {

    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {

        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {

    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        toggleFilter() {
            const filters = document.querySelector('.projects-filter__overflow-container');
            if (filters.classList.contains('--open')) {
                filters.classList.remove('--open');
                gsap.to(filters, {
                    duration: 0.4,
                    height: 0,
                    ease: 'Quad.easeOut',
                });
            } else {
                filters.classList.add('--open');
                gsap.to(filters, {
                    duration: 0.8,
                    height: 'auto',
                    ease: 'power2.out',
                });
            }
        },
    },
});
